import { debounce } from 'throttle-debounce';
import MoveTo from 'moveto';
const moveTo = new MoveTo();
export const scrolltoTop = (selector) => {
    const classNameEnter = 'swoopInBottom';
    const classNameLeave = 'swoopOutBottom';
    const delay = 200;
    const eventNames = ['load', 'touchmove', 'scroll'];
    // トップへ戻るボタンの取得
    const el = document.querySelector(selector);
    if (el === null) {
        return;
    }
    for (const eventName of eventNames) {
        window.addEventListener(eventName, debounce(delay, () => toggleScrollTop(el, classNameEnter, classNameLeave)));
    }
    // トップへ戻る
    el.addEventListener('click', () => {
        moveTo.move(document.body);
    });
};
/**
 * ボタンのトグル
 * @param el
 * @param classNameEnter
 * @param classNameLeave
 */
const toggleScrollTop = (el, classNameEnter, classNameLeave) => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // 最初にページを読み込んだときの処理
    if (scrollTop === 0
        && !el.classList.contains(classNameEnter)
        && !el.classList.contains(classNameLeave)) {
        return;
    }
    el.classList.remove('mute');
    if (scrollTop > 0) {
        el.classList.remove(classNameLeave);
        el.classList.add(classNameEnter);
    }
    else {
        el.classList.remove(classNameEnter);
        el.classList.add(classNameLeave);
    }
};
